export default {
 // 版本再次还原
  GetRegularExpression (type, expression) {
    // expression = /^(\+86|0086)?\s*1[34578]\d{9}$/
    switch (type) {
      case 'telphone':
        expression = /^(\+86|0086)?\s*1[3456789]\d{9}$/
        break
      case 'phone':
        expression = /^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(|-[0-9]{1,4})?$/
        break
      case 'email':
        expression = /^\w+[@](\w|\d){2,}[.](\w|\d){2,3}(([.]|\w|\d){2,3})?$/
        break
      case 'float':
        expression = /^([+-]?)\d*\.\d+$|(^[0-9]\d*$)/
        break
      case 'double2':
        expression = /^([+-]?)\d*\.\d{0,2}$|(^[0-9]\d*$)/
        break
      case 'linkAddr':
        expression = /^(http|ftp|https):\/\//
        break
      case 'positiveInteger':
        expression = /(^[1-9]\d*$)/
        break
      case 'pwd':
        // expression = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
        expression = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@+-=#*$%_]{8,}$/
        break
      case 'carno':
        // expression = /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/
        expression = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z_0-9挂学警港澳]{5}$/
        break
      case 'cardid':
        expression = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/
        break
      case 'font':
        // expression = /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/
        expression = /^[A-Za-z]+$/
        break
      case 'web':
        expression = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/
        break
      case 'qq':
        expression = /^[1-9]\d{4,11}$/
        break
      case 'url':
        expression = /(http|https):\/\/([\w.]+\/?)\S*/
        break
    }
    return expression
  }
}
